// Hooks
import { createFormContext, useForm } from 'hooks';

export const CaseContext = createFormContext();

export const useCase = useForm;
export default useCase;
